import {
    BiSolidDashboard,
    BiStation,
    BiBroadcast,
    BiSolidUserRectangle,
    BiCog,
  } from "react-icons/bi";
  import { Link } from "react-router-dom";
  import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
  
  export function DashboardSidebar({ userName, route }) {

    // user
    const user = useSelector((state) => state.user);
    console.log('User', user.user)

    // Track whether dropdown is open
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    // Reference to the user-section div (for outside-click detection)
    const userSectionRef = useRef(null);
  
    const handleToggleMenu = () => {
      setIsMenuOpen((prev) => !prev);
    };
  
    // Close the menu if we click outside userSectionRef
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          userSectionRef.current &&
          !userSectionRef.current.contains(event.target)
        ) {
          setIsMenuOpen(false);
        }
      }
      // Register event listener on mousedown
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Cleanup on unmount
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    return (
      <div className="h-screen w-64 bg-gray-900 text-white flex flex-col justify-between fixed">
        {/* Logo */}
        <div className="p-4">
          <Link to="/dashboard" className="hover:opacity-75">
            <h1 className="text-yellow-500 text-2xl mb-2">Eagle Aerospace</h1>
            <h2 className="text-gray-500 text-l">ADEW Support Portal</h2>
          </Link>
        </div>
  
        {/* Navigation */}
        <nav className="flex flex-col space-y-2 mt-4">
          <Link
            to="/dashboard"
            className={`flex items-center px-4 py-2 ${
              route === "/dashboard" ? "bg-gray-700" : "hover:bg-gray-700"
            }`}
          >
            <BiSolidDashboard className="mr-3" /> Dashboard
          </Link>
          <Link
            to="/pingstations"
            className={`flex items-center px-4 py-2 ${
              route === "/pingstations" ? "bg-gray-700" : "hover:bg-gray-700"
            }`}
          >
            <BiStation className="mr-3" /> Pingstations
          </Link>
          <Link
            to="/broadcast"
            className={`flex items-center px-4 py-2 ${
              route === "/broadcast" ? "bg-gray-700" : "hover:bg-gray-700"
            }`}
          >
            <BiBroadcast className="mr-3" /> Broadcast
          </Link>
          <Link
            to="/users"
            className={`flex items-center px-4 py-2 ${
              route === "/users" ? "bg-gray-700" : "hover:bg-gray-700"
            }`}
          >
            <BiSolidUserRectangle className="mr-3" /> Users
          </Link>
        </nav>
  
        {/* User Section */}
        <div className="mt-auto relative" ref={userSectionRef}>
          <button
            className="w-full flex items-center justify-between px-4 py-3 bg-gray-800 hover:bg-gray-700"
            onClick={handleToggleMenu}
          >
            <span className="text-sm">Hey, {userName}</span>
            <div>
              <BiCog className="text-lg" />
            </div>
          </button>
  
          {isMenuOpen && (
            <div className="absolute bottom-14 left-0 w-full bg-gray-800 z-10 shadow-md">
              <ul className="flex flex-col">
                {/* Profile link */}
                <li>
                  <Link
                    to={`/users/edit/${user.user.id}`}
                    className="block px-4 py-2 hover:bg-gray-700"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    User Profile
                  </Link>
                </li>
                {/* Logout link */}
                <li>
                  <Link
                    to="/logout"
                    className="block px-4 py-2 hover:bg-gray-700"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }
  